import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PictureInPictureIcon from '@mui/icons-material/PictureInPicture';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';

/**
 * Toggle for how record details open when a list row is clicked (matches Job Requirements).
 * Label and mode toggles stay on one row.
 */
export default function ListDetailOpenModeBar({
  value,
  onChange,
  label = 'Open Record In',
  sx,
}) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: 1.5,
        minWidth: 0,
        maxWidth: '100%',
        ...sx,
      }}
    >
      <Typography
        variant="body2"
        component="span"
        color="text.secondary"
        sx={{
          fontWeight: 600,
          whiteSpace: 'nowrap',
          flexShrink: 0,
          lineHeight: 1.2,
        }}
      >
        {label}
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_e, v) => v != null && onChange(v)}
        aria-label="How to open record details"
        sx={{ flexShrink: 0 }}
      >
        <ToggleButton value="page" aria-label="New page">
          <OpenInNewIcon fontSize="small" sx={{ mr: 0.5 }} />
          New page
        </ToggleButton>
        <ToggleButton value="popup" aria-label="Popup">
          <PictureInPictureIcon fontSize="small" sx={{ mr: 0.5 }} />
          Popup
        </ToggleButton>
        <ToggleButton value="side" aria-label="Side panel">
          <ViewSidebarIcon fontSize="small" sx={{ mr: 0.5 }} />
          Side
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
